export default __webpack_public_path__ + "static/media/play-icon.f2e02014.svg";